
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class ButtonDownload extends Vue {
  @Prop({ required: false, default: false })
  downloading!: boolean;

  @Prop({ required: false, default: true })
  enabled!: boolean;

  @Prop({ required: false, default: "Download" })
  displayText!: string;

  @Prop({ required: false, default: "Download Report" })
  toolTipText!: string;

  buttonClicked(): void {
    this.$emit("button-download-clicked");
  }
}
